<template>
  <mt-header fixed :title="title" style="background-color: #fff; color: #323233;font-size: 16px;">
    <router-link to="/" slot="left">
      <mt-button icon="back"></mt-button>
    </router-link>
    <template slot="right" v-if="this.$route.meta.titleType == 1">
      <div>
        期数<input type="num" class="period" v-model="period" @input="validateNum">
      </div>
    </template>
    <mt-button icon="more" slot="right" @click="selectedYear" v-if="this.$route.meta.titleType == 2"></mt-button>
  </mt-header>
</template>

<style>
@media screen and (min-width: 769px) {
  .mint-header {
    width: 480Px;
    margin: 0 auto
  }
}

.period {
  height: 22px;
  width: 25%;
  outline: none;
  background: #f6f6f6;
  border-radius: 6px;
  border: 1px solid #bcbcbc;
  text-align: center;
  margin-left: 6px
}
</style>


<script>
export default {
  name: 'Header',
  data() {
    return {
      title: '',
      period: 100,
      year: '',
      period1: this.period
    }
  },
  watch: {
    '$route'(to) {
      this.title = to.meta.title;
      var period = 100;
      to.meta.titleType == 0 && this.$emit("refreshHome");
      to.meta.titleType == 1 && this.$emit("refreshHomePeriod", period);
      to.meta.titleType == 2 && this.$emit("refreshHomeYear", null);
      this.period = period;
      this.period1 = period;
    }
  },
  methods: {
    validateNum() {
      var period = this.period.replace(/[^0-9]/g, '');
      period != '' && period != this.period1 && (this.period1 = period, this.period = period, this.$emit("refreshHomePeriod", period));
    },
    selectedYear() {
      this.$emit("showSelectedYear", this.year);
    },
    setYear(year) {
      this.year = year;
    }
  }
}
</script>